import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "oc-azure",
  "use": "oc-azure-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"oc-azure\"><path d=\"M558.848 165.76L269.269333 781.952l-203.477333-2.218667 227.114667-390.869333 265.941333-223.146667m31.232 48.64l368.085333 643.84H277.333333l414.976-74.026666-217.301333-258.346667z\" fill=\"#1E88E5\" p-id=\"1476\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol